import React ,{useState} from "react";
import {
  Button,
  DatePicker,
  Table,
  TimePicker,
  Typography,
  Input,
  Select,
  Form,
  InputNumber,
  Divider,
  Row,
  Col,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

function DashboardFormTable() {
  const columns = [
    {
      title: "#",
      dataIndex: "index",
    },
    {
      title: "Date",
      dataIndex: "datePicker",
    },
    {
      title: "Time",
      dataIndex: "timePicker",
    },
    {
      title: "Day",
      dataIndex: "day",
    },
    {
      title: "Notes(optional)",
      dataIndex: "note",
    },
  ];

  const [data, setData] = useState([
    {
      key: "1",
      index: "1",
      datePicker: <DatePicker style={{ width: "100%" }} />,
      timePicker: <TimePicker style={{ width: "100%" }} />,
      day: "___",
      note: (
        <Row gutter={8}>
          <Col flex="auto">
            <TextArea
              rows={1}
              placeholder="Write note..."
              className="optional-text"
            />
          </Col>
          <Col>
            <DeleteOutlined style={{ color: "red", cursor: "pointer" }} />
          </Col>
        </Row>
      ),
    },
  ]);



  return (
    <>
      <Title level={5} className="secondary-heading">
        Session Scheduling
      </Title>

      <Table columns={columns} dataSource={data} pagination={false} bordered />

      <Paragraph className="discription-text">
        Pick a date for each session; "Day" fills automatically.
      </Paragraph>

      <Title level={5} className="secondary-heading">
        Payment (Universal)
      </Title>

      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            label="Total Estimated Cost"
            name="estimatedCost"
            layout="vertical"
          >
            <InputNumber
              min={1}
              max={1000000}
              placeholder="e.g. 75000"
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="Advance Payment"
            name="advancePayment"
            layout="vertical"
          >
            <InputNumber
              min={1}
              max={1000000}
              placeholder="e.g. 20000"
              style={{ width: "100%", borderRadius: "8px" }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="Remaining Balance"
            name="remainingBalance"
            layout="vertical"
          >
            <InputNumber
              min={1}
              max={1000000}
              placeholder="Auto/Manual"
              style={{ width: "100%", borderRadius: "8px" }}
            />
            <Paragraph className="discription-text" style={{ marginTop: "4px" }}>
              You can leave blank and fill later.
            </Paragraph>
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Text>Admin / Doctor Notes</Text>
          <TextArea
            placeholder="Important Instructions or remarks..."
            rows={4}
          />
          <Divider />
        </Col>
      </Row>
    </>
  );
}

export { DashboardFormTable };
